import React from "react";
import { Field } from "types";
import RangeField from "components/utility/GeneratedField/components/RangeField/RangeField";

interface Props {
  field: Field;
  defaultValue: any;
  onChange: (value: any) => void;
  error?: string;
}

const RangeFieldWrapper = ({ field, defaultValue, onChange, error }: Props) => {
  return (
    <RangeField
      name={field.name}
      label={field.label}
      min={Number(field.min) || 0}
      max={Number(field.max) || 10}
      minLabel={field.minLabel}
      maxLabel={field.maxLabel}
      scoreMappings={field.scoreMappings}
      defaultValue={
        defaultValue ||
        Math.round(((Number(field.min) ?? 0) + (Number(field.max) ?? 10)) / 2)
      }
      value={defaultValue}
      hint={field.hint}
      error={error}
      onChange={(value) => {
        onChange(value);
      }}
    />
  );
};

export default RangeFieldWrapper;
